<script setup>
import { ref, watch } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useAppStore } from '../store/app';
import utils from '../common/utils';

const route = useRoute();
const router = useRouter();
const store = useAppStore();

const currentRouteName = ref('Subscription Dashboard');
const currentSelectedProduct = ref('');

/**
 * When a product is selected and route changes, append
 * the product name to the current route e.g `Customer (DynamicOdds)`
 */
watch(
  () => route.name, // Watch for route change
  (newState) => {
    currentRouteName.value = newState;
    const notSubscriptionDashboard =
      currentRouteName.value !== 'Subscription Dashboard' && !utils.isEmpty(store.selectedProduct);
    const newRouteName = notSubscriptionDashboard ? `(${store.selectedProduct})` : '';
    currentSelectedProduct.value = newRouteName;
  },
);
</script>

<template>
  <v-app-bar app prominent class="nav">
    <v-btn
      v-if="currentRouteName !== 'Subscription Dashboard'"
      class="nav__left-arrow-icn"
      icon
      @click="router.back(-1)">
      <v-icon>mdi-arrow-top-left</v-icon>
    </v-btn>

    <v-btn v-else @click="router.push('/')" icon flat clas="mr-2">
      <v-icon class="nav__dashboard-icn">mdi-view-dashboard</v-icon>
    </v-btn>

    <v-toolbar-title>
      <span class="nav__title">{{ currentRouteName }} {{ currentSelectedProduct }}</span>
    </v-toolbar-title>

    <v-spacer></v-spacer>
    <!--
    <v-btn class="not-allowed" variant="text" icon="mdi-magnify" color="text"></v-btn>
    <v-btn class="not-allowed" variant="text" icon="mdi-filter" color="text"></v-btn>
    <v-btn class="not-allowed endi" variant="text" icon="mdi-dots-vertical" color="text"></v-btn>
    -->
  </v-app-bar>
</template>

<style lang="scss" scoped>
.nav {
  background-color: rgba(var(--v-theme-background-primary));
  color: rgba(var(--v-theme-text-primary));
  box-shadow: none !important;
  padding-right: 35px;

  &__left-arrow-icn {
    transform: rotate(-45deg);
  }

  &__dashboard-icn {
    transform: rotate(-45deg);
    color: rgba(var(--v-theme-primary));
    margin-right: -15px;
  }

  &__title {
    font-weight: 600;
    color: rgba(var(--v-theme-text-secondary));
  }
}
</style>
